import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { onKeyPress } from '../../utils/keypress';
import * as api from '../../api';
import * as store from '../../reducers/store';

import * as Cache from '../../utils/cache';
import { sendEventMessage, Message } from '../../utils/native';

import styles from './index.module.css';
import { useSelector } from 'react-redux';

const Logout: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams<{ authenticationCode: string }>();
  /** Short term solution for an awkwardness for quartet https://app.asana.com/0/home/1201862110650014/1203169188241575 where if user has completed the form then logs out, when they try log back in they will hit an login error because the form is already completed, and the form mentions `look forward to your appointment` which doesn't apply to quatet */
  const formSet = useSelector((store: store.All) =>
    store?.selectedFormSetId ? store.formSets[store?.selectedFormSetId] : null,
  );
  if (formSet?.encounter?.source === api.Encounter.Source.Registration) {
    return null;
  }
  const handleLogout = async () => {
    await api.client.Previsit.logout();
    if ((window as any).webkit) {
      sendEventMessage(Message.Logout);
    } else {
      Cache.clearCache();
      history.push({
        pathname: `/login/${params.authenticationCode}`,
        search: '',
      });
    }
  };

  return (
    <span
      tabIndex={0}
      role="button"
      className={styles.Logout}
      onClick={handleLogout}
      onKeyDown={(e) =>
        onKeyPress({
          e,
          onConfirm: () => handleLogout(),
        })
      }
    >
      {t('Logout')}
    </span>
  );
};

export default Logout;
